import React from 'react'
import { Box, Text } from '@node-space/ui-components'

export interface SidePanelRowProps {
  label: string
  content: string
}

export const SidePanelRow = ({ label, content }: SidePanelRowProps) => {
  return (
    <Box flex justify="between" gapX={16} paddingY={8}>
      <Text color="subdued">{label}</Text>
      <Text variant="body-label" className="text-right">
        {content}
      </Text>
    </Box>
  )
}
